import React from 'react';
import {
  FaCalendarCheck, FaUsers, FaEdit, FaBriefcase, FaUserTie,
  FaMapMarkerAlt, FaEnvelope, FaDollarSign,
} from 'react-icons/fa';

export const ProDashOverviewTab = ({ profile, professionalType, setActiveTab }) => (
  <div className="grid md:grid-cols-2 gap-6">
    {/* Quick Actions */}
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h3 className="font-bold text-gray-900 mb-4">Quick Actions</h3>
      <div className="space-y-3">
        <button
          onClick={() => setActiveTab('consultations')}
          className="w-full flex items-center gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 text-left"
        >
          <FaCalendarCheck className="text-blue-600" />
          <div>
            <p className="font-medium text-gray-900">View Consultations</p>
            <p className="text-sm text-gray-500">See upcoming and past appointments</p>
          </div>
        </button>
        <button
          onClick={() => setActiveTab('referrals')}
          className="w-full flex items-center gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 text-left"
        >
          <FaUsers className="text-emerald-600" />
          <div>
            <p className="font-medium text-gray-900">Refer Colleagues</p>
            <p className="text-sm text-gray-500">Invite trusted professionals</p>
          </div>
        </button>
        <button
          onClick={() => setActiveTab('profile')}
          className="w-full flex items-center gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 text-left"
        >
          <FaEdit className="text-purple-600" />
          <div>
            <p className="font-medium text-gray-900">Edit Profile</p>
            <p className="text-sm text-gray-500">Update your information</p>
          </div>
        </button>
      </div>
    </div>

    {/* Profile Summary */}
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h3 className="font-bold text-gray-900 mb-4">Profile Summary</h3>
      <div className="space-y-3">
        <div className="flex items-center gap-3">
          <FaBriefcase className="text-gray-400" />
          <span className="text-gray-700">{professionalType}</span>
        </div>
        {profile?.company && (
          <div className="flex items-center gap-3">
            <FaUserTie className="text-gray-400" />
            <span className="text-gray-700">{profile.company}</span>
          </div>
        )}
        {profile?.location && (
          <div className="flex items-center gap-3">
            <FaMapMarkerAlt className="text-gray-400" />
            <span className="text-gray-700">{profile.location}</span>
          </div>
        )}
        {profile?.email && (
          <div className="flex items-center gap-3">
            <FaEnvelope className="text-gray-400" />
            <span className="text-gray-700">{profile.email}</span>
          </div>
        )}
        {profile?.hourly_rate && (
          <div className="flex items-center gap-3">
            <FaDollarSign className="text-gray-400" />
            <span className="text-gray-700">${profile.hourly_rate}/hour</span>
          </div>
        )}
      </div>
      {profile?.specialties?.length > 0 && (
        <div className="mt-4">
          <p className="text-sm text-gray-500 mb-2">Specialties</p>
          <div className="flex flex-wrap gap-2">
            {profile.specialties.map((spec) => (
              <span key={spec} className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-sm">
                {spec}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  </div>
);
